export default __webpack_public_path__ + "static/media/NIAS0560.34I-40199_-23850_0.cedd8d8f.jpg";